/**
 * Created by intellicar-kazi on 20/12/21.
 */
 import React, {Component} from 'react';
 import './SwiggyWidget.css';
 import FoldingTable from '../FoldingTable/FoldingTable';
 import _ from 'lodash';
 import InTable from '../InTable/InTable';
 export default class SwiggyWidget extends Component {
     state = {
         index: 0,
         aggregate: false, 
         showTable: false,
         dataPerday: false,
         toggle:false,
         activeTab:0
     }
     
     onHover=(data)=>{
  this.setState({Vehicles:data})
     }
     onStackBarHover=(data)=>{
       this.setState({opVehicles:data})
     }
 
     setTab =index=> {
         if(index == 2){
           let stats = {}
           if(window.swiggyTableData){
           stats = this.generateStats();
            this.setState({stats: stats});
           }
         }
         if(index == 1){
             window.tab = 1
             this.setState({aggregate:true})
         }
         if(index == 0){
            window.tab = 0
            this.setState({aggregate:false})
        }
         // _.set(window.rideReportTable, 'index', index);
         this.setState({index});
     }

     toggleAggregate = () => {
         _.set(window.swiggyTableData, 'aggregate', !this.state.aggregate);
         this.setState(state => ({aggregate: !state.aggregate}));
     }
     componentDidUpdate(){
         if(window.swiggyAggData && this.state.index === 1) {
          this.refs.table.setData(window.swiggyAggData);
          
    }
     }
     render(){
         let tableData = {
            head: [
                        { key:'date', name:'Date'},
                        { key: "vehicleno", name: "", name: "Vehicle No" },
                        { key:'vehicletype', name:'Vehicle Type'},
                        { key: "deid", name: "Driver Id" },
                        { key: "ordertype", name: "Order Type" },
                        { key: "count", name: "Order Count" },
                        { key: "duration", name: "Duration" },
                        { key: "distance", name: "Distance (km)" },
                        { key: "kmpl", name: "Mileage (kmpl)" },
                        { key: "avgspeed", name: "Avg Speed (km)" },
                        { key: "drivingtime", name: "Driving Time" },
                        { key:'idlingtime', name:'Idling Time'},
                        { key:'waitingtime', name:'Waiting Time'},
                        { key: "cost", name: "Rider Cost(Rs)" },
                        { key: "earning", name: "Earning(Rs)" },
                        { key: "netearning", name: "Net Earnings (Rs)" },
                      ],
             _position: {
                 width: 1000,
             }
         }
 
         let aggregate = {
            head: [
                        { key:'date', name:'Date'},
                        { key: "vehicleno", name: "", name: "Vehicle No" },
                        { key:'vehicletype', name:'Vehicle Type'},
                        { key: "deid", name: "Driver Id" },
                        { key: "ordertype", name: "Order Type" },
                        { key: "count", name: "Order Count" },
                        { key: "duration", name: "Duration" },
                        { key: "distance", name: "Distance (km)" },
                        { key: "kmpl", name: "Mileage (kmpl)" },
                        { key: "avgspeed", name: "Avg Speed (km)" },
                        { key: "drivingtime", name: "Driving Time" },
                        { key:'idlingtime', name:'Idling Time'},
                        { key:'waitingtime', name:'Waiting Time'},
                        { key: "cost", name: "Rider Cost(Rs)" },
                        { key: "earning", name: "Earning(Rs)" },
                        { key: "netearning", name: "Net Earnings (Rs)" },
                      ],
           _position: {
               width: 1000,
           }
       }
 
         let renderTogglBtn = () => {
           let {aggregate} = this.state;
           return this.state.index === 0 ? <button onClick={this.toggleAggregate} className={aggregate ? 'actv' : ''}>
               <i className={'fa fa-toggle-' + (aggregate ? 'on' : 'off')}></i> Aggregate
           </button> : null
       }
         return (
             <div className='SwiggyReportWidget'>
                 <div className='trw-tabs'>
                     <div className={('trwt-tab ' + (this.state.index === 0 ? 'active' : ''))} onClick={()=>this.setTab(0)}>Daily</div>
                     <div className={('trwt-tab ' + (this.state.index === 1 ? 'active' : ''))} onClick={()=>this.setTab(1)}>Aggregate</div>
                     {/* <div className="trwt-btns">
                         {renderTogglBtn()}
                     </div> */}
                 </div>
                 <div className='trw-container'>
 
                {window.swiggyTableData == undefined?<div className='trwc-tab'>
                             <div className="no-data">No Data</div>
                         </div>:window.swiggyTableData.length<1 &&<div className='trwc-tab'>
                             <div className="no-data">No Data</div>
                         </div>}

                        

{window.swiggyTableData &&this.state.index === 0 &&
                         <div className="trwc-tab">
                        <FoldingTable data ={window.swiggyTableData} />
                         </div>}

 
                       {this.state.index === 1 && this.state.aggregate  &&(
                         <div className='trwc-tab'>
                             <InTable ref="table" data={aggregate} />
                         </div>
                     )} 

                 </div>              
             </div>
         )
     }
 }
     